import './Pagination.css'
import React from 'react'
interface IPaginationProps {
  totalPages: number
  currentPage: number
  setCurrentPage: (page: number) => void
  nextPage: number
  previousPage: number
}

export const Pagination = (props: IPaginationProps)=> {
  const { totalPages, currentPage, previousPage, nextPage, setCurrentPage } = props
  const pages: number[] = []
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i)
  }
  const handleSwitchPage = (page: number) => {
    setCurrentPage(page)
    window.scrollTo(0,0)
  }
  const getPages = () : number[] => {
    if (pages.length <= 5) {
      return [...pages]
    }
    else {
      if (currentPage <= 3) {
        return [...pages.slice(0,5), 0, pages[pages.length -1]]
      }
      if (currentPage > 3 && currentPage <= pages.length - 2) {
        return [pages[0], 0, ...pages.slice(currentPage - 2, currentPage + 1), 0, pages[pages.length-1]]
      }
      if (currentPage >= pages.length - 2) {
        return [pages[0], 0, ...pages.slice(pages.length - 5)]
      }
    }
    return [...pages]
  }
  if (totalPages < 2) {
    return null
  }
  return (
    <div className={'pagination'}>
      <img
        className={'page_link switch left'}
        src={'/arrow_left_button_icon.png'}
        alt={'arrow left button icon'}
        onClick={() => {
          handleSwitchPage(previousPage)
        }}
      />

      {getPages().map((number, index) => {
        if (number === 0) {
          return (
            <input className={'page_link not_filled'} type={'button'} value={'...'} key={index} />
          )
        }
        return (
          <input
            key={index}
            className={currentPage === number ? 'page_link active' : 'page_link'}
            type={'button'}
            value={number}
            onClick={() => {
              handleSwitchPage(number)
            }}
          />
        )
      })}

      <img
        className={'page_link switch right'}
        src={'/arrow_right_button_icon.png'}
        alt={'arrow right button icon'}
        onClick={() => {
          handleSwitchPage(nextPage)
        }}
      />
    </div>
  )
}
